(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequirefdb2"];
parcelRequire.register("dEuwz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f06b04bf28c8423$export$2e2bcd8739ae039; });
var $9f06b04bf28c8423$var$switchAsset = function(accordion, group) {
    var _accordion_dataset;
    var groupAssets = group.querySelectorAll(".laf-accordion__feature");
    var relatedAssetId = accordion === null || accordion === void 0 ? void 0 : (_accordion_dataset = accordion.dataset) === null || _accordion_dataset === void 0 ? void 0 : _accordion_dataset.assetId;
    /* === Toggle visibility of related assets === */ if (relatedAssetId && groupAssets) Array.from(groupAssets).forEach(function(asset) {
        if (asset.id === relatedAssetId) asset.classList.add("--active");
        else asset.classList.remove("--active");
    });
};
function $9f06b04bf28c8423$export$2e2bcd8739ae039() {
    var accordionGroups = document.getElementsByClassName("laf-accordion-group");
    if (!accordionGroups) return;
    Array.from(accordionGroups).forEach(function(group) {
        // For animated assets, wait until the animation starts
        group.addEventListener("accordionOpen", function(e) {
            var accordion = e.target;
            $9f06b04bf28c8423$var$switchAsset(accordion, group);
        });
    });
}

});

})();
//# sourceMappingURL=list-and-feature.5193e2f4.js.map
